import Swiper, { A11y, Autoplay, Controller, EffectFade, Keyboard, Navigation } from 'swiper';

import '../../sass/blocks/home-hero.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    let winWidth = window.innerWidth;
    
    const $homeHeros = document.querySelectorAll('.home-hero');
    const $siteHeaderInnerWrapper = document.querySelector('.site-header__inner-wrapper');

    if (!$homeHeros) return;

    $homeHeros.forEach($homeHero => {
        const $images = $homeHero.querySelector('.home-hero__images');
        const $carousel = $homeHero.querySelector('.home-hero__carousel');
        const $imagesSpacer = $homeHero.querySelector('.home-hero__images-spacer');
        const $detailsCarousel = $homeHero.querySelector('.home-hero__details-carousel');
        const $detailsCarouselSlides = $detailsCarousel.querySelectorAll('.swiper-slide');
        const $navigationPrev = $homeHero.querySelector('.home-hero__navigation-prev');
        const $navigationNext = $homeHero.querySelector('.home-hero__navigation-next');

        let detailsCarousel = null;
        let imageCarousel = null;
        let carouselInitiated = false;

        const detailsCarouselHeight = () => {
            if (!$detailsCarousel || !$detailsCarouselSlides) return;

            let maxHeight = 0;

            $detailsCarouselSlides.forEach($detailsCarouselSlide => {
                $detailsCarouselSlide.style.height = 'auto';

                const slideHeight = $detailsCarouselSlide.clientHeight;

                if (slideHeight > maxHeight) {
                    maxHeight = slideHeight;
                }
            });

            $detailsCarousel.style.height = `${maxHeight}px`;

            if (imageCarousel) {
                imageCarousel.controller.control = detailsCarousel;
            }
        };

        const initDetailsCarousel = () => {
            if (!$detailsCarousel) return;

            detailsCarousel = new Swiper($detailsCarousel, {
                modules: [ EffectFade ],
                allowTouchMove: false,
                direction: 'vertical',
                effect: noMotionPreference.matches ? 'slide' : 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 300
            });
        }

        const initImageCarousel = () => {
            if (!$carousel || carouselInitiated) return;

            imageCarousel = new Swiper($carousel, {
                modules: [ A11y, Autoplay, Controller, EffectFade, Keyboard, Navigation ],
                autoplay: {
                    disableOnInteraction: false
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                loop: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 300,
                controller:  {
                    control: detailsCarousel
                }
            });

            $navigationNext.addEventListener('click', () => {
                if (imageCarousel.activeIndex + 1 >= $detailsCarouselSlides.length) {
                    imageCarousel.slideTo(0);
                } else {
                    imageCarousel.slideNext();
                }
            });

            $navigationPrev.addEventListener('click', () => {
                if (imageCarousel.activeIndex === 0) {
                    imageCarousel.slideTo($detailsCarouselSlides.length - 1);
                } else {
                    imageCarousel.slidePrev();
                }
            });
            
            carouselInitiated = true;
        };

        const initImages = () => {
            if (!$images || !$imagesSpacer) return;

            let scale = 1;

            if ($homeHero.clientWidth < $homeHero.clientHeight) {
                $images.style.width = '';
                $images.style.height = `${$homeHero.clientWidth}px`;

                scale = $imagesSpacer.clientWidth / $homeHero.clientWidth;
            } else {
                $images.style.width = `${$homeHero.clientHeight}px`;
                $images.style.height = '';

                scale = $imagesSpacer.clientHeight / $homeHero.clientHeight;
            }

            const xPos = $imagesSpacer.getBoundingClientRect().x - $homeHero.getBoundingClientRect().x;
            const yPos = $imagesSpacer.getBoundingClientRect().y - $homeHero.getBoundingClientRect().y;
            
            $images.style.transform = `translate(${xPos}px, ${yPos}px) scale(${scale})`;
        };

        const expandImages = () => {
            if (!$images) return;

            $images.classList.add('home-hero__images--animate-in');
        };

        window.addEventListener('resize', () => {
            if (winWidth === window.innerWidth) return;

            detailsCarouselHeight();
            initImages();
            expandImages();

            winWidth = window.innerWidth;
        });

        window.addEventListener('onscreen', () => {
            expandImages();

            setTimeout(() => {
                initImageCarousel();
            }, 1000);
        });

        detailsCarouselHeight();
        initDetailsCarousel();
        initImages();
    });
})();
